import {
  GET_CLIENTS,
  GET_CLIENTS_REQUEST,
  CREATE_CLIENT,
  CREATE_CLIENT_REQUEST,
  UPDATE_CLIENT_STATUS,
  UPDATE_CLIENT_STATUS_REQUEST
} from '../constants/ClientsActionTypes';

const initialState = {
  loading: true,
  clients: {}
};

const mapClientsToId = (prevState, nextState) => {
  return nextState.reduce((previousResult, current) => {
    previousResult[current.id] = {
      ...prevState[current.id],
      ...current
    };
    return previousResult;
  }, {});
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CLIENTS: {
      let clients;
      const clientList = action.res || [];
      if (action.pageStart === 0) {
        clients = mapClientsToId({}, clientList);
      } else {
        clients = mapClientsToId(state.clients, clientList);
      }
      return {
        loading: false,
        clients
      };
    }
    case GET_CLIENTS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case CREATE_CLIENT:
      return {
        ...state,
        clients: {
          ...state.clients,
          [action.res.id]: action.res
        }
      };
    case CREATE_CLIENT_REQUEST:
      return {
        ...state
      };
    case UPDATE_CLIENT_STATUS:
      return {
        ...state,
        clients: {
          ...state.clients,
          [action.res.id]: {
            ...state.clients[action.res.id],
            ...action.res,
          },
        },
        loading: false,
      };
    case UPDATE_CLIENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
